import { api } from "./api";

export class TrackerModelService {
  async post(value: string) {
    try {
      const response = await api.post(`/tracker-model`, value);
      return response;
    } catch (error: any) {
      return error.response;
    }
  }

  async get() {
    try {
      const response = await api.get(`/tracker-model`);
      return response.data.data;
    } catch (error: any) {
      return error.response;
    }
  }

  async getById(id: string) {
    try {
      const response = await api.get(`/tracker-model/${id}`);
      return response.data.data;
    } catch (error: any) {
      return error.response;
    }
  }

  async patch(value: string, id: string) {
    try {
      const response = await api.patch(`/tracker-model/${id}`, value);
      return response;
    } catch (error: any) {
      return error.response;
    }
  }

  async delete(id: string) {
    try {
      const response = await api.delete(`/tracker-model/${id}`);
      return response;
    } catch (error: any) {
      return error.response;
    }
  }
}
